import { compareMoney, isZeroMoney } from "@ibada/shared-types/finance"

import type { MoneyText } from "@/features/finance/model/finance-types"
import { formatMoneySafe, isRatioDisplay } from "@/features/finance/overview/lib/overview-format"

export interface WatchlistDisplayRow {
  balance: MoneyText
  currency: string
}

function displayAmountNumber(amount: MoneyText): number {
  const parsed = Number.parseFloat(amount)
  return Number.isFinite(parsed) ? parsed : 0
}

export function isZeroWatchlistAmount(amount: MoneyText, currency: string): boolean {
  return isRatioDisplay(currency) ? displayAmountNumber(amount) === 0 : isZeroMoney(amount, currency)
}

export function compareWatchlistAmountsDesc<T extends WatchlistDisplayRow>(a: T, b: T): number {
  if (isRatioDisplay(a.currency) || isRatioDisplay(b.currency)) {
    return displayAmountNumber(b.balance) - displayAmountNumber(a.balance)
  }
  return compareMoney(b.balance, a.balance, a.currency)
}

export function formatWatchlistAmount(amount: MoneyText, currency: string): string {
  return formatMoneySafe(amount, currency)
}
